import { buildCssInlineBase } from './build-css-inline-base';
import { buildCssInlineSsm } from './build-css-inline-ssm';
export function buildCssInline(_a) {
    var css = _a.css, experiments = _a.experiments;
    return [buildCssInlineBase({ experiments: experiments }), buildCssInlineSsm(css)].join('');
}
//# sourceMappingURL=build-css-inline.js.map